import { Button, Col, Row } from "antd";
import { useEffect } from "react";
import "../App.css";
import { ReactComponent as TDLogo } from "../Icons/transdyne-01.svg";
import bgimg from "../images/Hero-image-V1.png";

export const AppRedirect = () => {
  const appRedirectURL = "transcribe://auth";

  useEffect(() => {
    document.body.classList.toggle("no-scroll", !(window.innerWidth <= 767));
  }, []);

  return (
    <Row className="row">
      <Col
        xs={24}
        sm={24}
        md={14}
        lg={14}
        xl={14}
        className="left-col"
        style={{
          backgroundSize: "contain",
          backgroundImage: `url(${bgimg})`,
          backgroundColor: "#f0f4f8"
        }}></Col>

      <Col
        xs={24}
        sm={24}
        md={10}
        lg={10}
        xl={10}
        className="right-col"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }}>
        <TDLogo className="login-logo" style={{ marginBottom: "2.5rem" }} />
        <div className="wrap-text font-1212">
          Revolutionizing Healthcare Documentation with Virtual Scribing Solution
        </div>
        <Button
          type="primary"
          onClick={() => (window.location.href = appRedirectURL)}
          className="button-login">
          Continue to App
        </Button>
      </Col>
    </Row>
  );
};
